import LedgerSnapShotUseCase from "@domains/useCases/Reports/LedgerReport/LedgerSnapShot";
import LedgerDetailUseCase from "@domains/useCases/Reports/LedgerReport/LedgerDetail";
import LedgerSnapShotExtentionUseCase from "@domains/useCases/Reports/LedgerReport/LedgerSnapShotExtention";
import LedgerContractNoteUseCase from "@domains/useCases/Reports/LedgerReport/LedgerContractNote";
import LedgerContractPDFUseCase from "@domains/useCases/Reports/LedgerReport/LedgerContractPDF";
import EmailReport from "@domains/useCases/Reports/common/emailReport/emailReport";
import DownloadPDFReport from "@domains/useCases/Reports/common/downloadReport/downloadPdfReport";
import DownloadExcelReport from "@domains/useCases/Reports/common/downloadReport/downloadExcelReport";
import { LedgerReportCommonUseCase, FilterUseCase, } from "@domains/useCases/Reports/LedgerReport/LedgerCommonUseCase";
export default (repositories) => {
    return {
        snapShot: new LedgerSnapShotUseCase(repositories.ledger),
        detail: new LedgerDetailUseCase(repositories.ledger),
        sendEmailReports: new EmailReport(repositories.download),
        downloadPDFReports: new DownloadPDFReport(repositories.download),
        downloadExcelReports: new DownloadExcelReport(repositories.download),
        snapshotExtention: new LedgerSnapShotExtentionUseCase(repositories.ledger),
        contractNote: new LedgerContractNoteUseCase(repositories.ledger),
        contractPDF: new LedgerContractPDFUseCase(repositories.ledger),
        commonUsecase: new LedgerReportCommonUseCase(new FilterUseCase()),
    };
};
